import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Alert, Button, Col, Container, Row } from "reactstrap";

const queryString = require("query-string");

type Props = {
  imageSrc: string;
  altText: string;
  alertColor: "success" | "danger";
  message: React.ReactNode;
  action: { text: string; redirect: string };
};

const PaymentStatusLayout = ({
  imageSrc,
  altText,
  alertColor,
  message,
  action,
}: Props) => {
  const history = useHistory();
  const location = useLocation();
  const parsed = queryString.parse(location.search);

  const refNum = parsed.refNum;

  return (
    <Container
      customStyle={{ height: "100vh" }}
      className="d-flex flex-column justify-content-center"
    >
      <Row>
        <Col className="d-flex justify-content-center">
          <img
            style={{ width: "120px", height: "120px" }}
            src={imageSrc}
            alt={altText}
          />
        </Col>
      </Row>

      <Alert className="text-center my-5 py-4" color={alertColor}>
        {message}
        {refNum && (
          <p className="text-center m-0 p-0">
            شماره پیگیری: <strong>{refNum}</strong>
          </p>
        )}
      </Alert>

      <Row>
        <Col className="d-flex justify-content-center">
          <Button
            type="button"
            className="px-5 py-2 border-0 mt-4"
            onClick={() => history.push(action.redirect)}
          >
            {action.text}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentStatusLayout;
